module.exports = __webpack_public_path__ + "static/media/banner-fraude-mobile.f9f4884e.png";